import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';

import { SnippetEditorModal } from '../modals/SnippetEditorModal.tsx';
import { DeleteSnippetModal } from '../modals/DeleteSnippetModal.tsx';
import { SnippetEditorModalMode, type Snippet } from '../snippetTypes.ts';

const EMPTY_ADF = { type: 'doc' as const, version: 1 as const, content: [] };

export type SnippetActionHandlersOptions = {
	onEdit?: (snippet: Snippet) => void;
	onDuplicate?: (snippet: Snippet) => void;
	onDelete?: (snippet: Snippet) => void;
};

export const useSnippetActionHandlers = (options: SnippetActionHandlersOptions = {}) => {
	const { onEdit, onDuplicate, onDelete } = options;
	const { showModal } = useDialogs();

	const handleEdit = (snippet: Snippet) => {
		if (onEdit) {
			onEdit(snippet);
		} else {
			showModal(SnippetEditorModal, {
				mode: SnippetEditorModalMode.EDIT,
				adf: EMPTY_ADF,
				snippet,
			} as any);
		}
	};

	const handleDuplicate = (snippet: Snippet) => {
		// TODO: Implement duplicate (e.g. open duplicate modal or inline flow)
		onDuplicate?.(snippet);
	};

	const handleDelete = (snippet: Snippet) => {
		if (onDelete) {
			onDelete(snippet);
		} else {
			showModal(DeleteSnippetModal, { snippet });
		}
	};

	return { handleEdit, handleDuplicate, handleDelete };
};
